import { defineComponent as _defineComponent } from 'vue'
import { SnowplowContext, SnowplowModuleContext } from '@/helpers/tracking/providers';
import { PosterSponsoredRecImages } from '@/interfaces/components/poster/PosterGraphql';
import { SponsoredAdFragment } from '@/pages/graphql/fragments/SponsoredAd.fragment';
import { computed } from 'vue';
import { useCampaignInfo } from '../useSendBidId';
import { Maybe } from '@/@types/graphql-types';
import PictureComp from '@/components/picture/PictureComp.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SRCompanion',
  props: {
    sponsoredAd: null,
    lazy: { type: Boolean, default: true },
    additionalContexts: { default: () => [] },
    hideContent: { type: Boolean }
  },
  emits: ["onPosterClickOut", "imageError"],
  setup(__props: any) {

const props = __props as { sponsoredAd: NonNullable<SponsoredAdFragment>, lazy: boolean, additionalContexts: (SnowplowModuleContext | SnowplowContext)[], hideContent?: boolean };





const { campaignNode, promotionalTitle, releaseYear } = useCampaignInfo(() => props.sponsoredAd.campaign);

const posterSRImage = computed<PosterSponsoredRecImages | null>(() => {
	let posterUrl = props.sponsoredAd.campaign?.posterOverride || campaignNode?.value.content.posterUrl;
	if (!posterUrl) return null;

	if (posterUrl.startsWith('/')) {
		posterUrl = `${JW_CONFIG.IMAGESCALER_URL}${posterUrl.replace('{profile}', 's332')}`;
	}

	return {
		imageUrl: posterUrl,
		sourceSets: [
			{
				srcSet: posterUrl.replace(/\.{?\w+}?$/, '.avif'),
				imageProp: {
					extension: '.avif',
					type: 'image/avif',
				},
				sourceProp: {
					viewport: 'desktop',
				},
				media: null,
			},
		],
	};
});

return { __sfc: true,props, campaignNode, promotionalTitle, releaseYear, posterSRImage, PictureComp }
}

})